import React, { useState } from "react";
import Modal from "react-modal";

import FormSingleCheckbox from "../component/FormSingleCheckbox";

export default function RegisterModal({
  registerModal,
  setRegisterModal,
  register,
  navigate,
}) {
  const [optIn, setOptIn] = useState();

  return (
    <Modal
      isOpen={registerModal}
      aria={{
        labelledby: "heading",
        describedby: "full_description",
      }}
      onRequestClose={() => setRegisterModal(false)}
      className="Teaser"
      style={{
        overlay: {
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.75)",
          zIndex: 10000,
        },
        content: {
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: " translate(-50%, -50%)",
          maxHeight: "90vh",
          overflowX: "auto",
        },
      }}
    >
      <div className="Teaser--inner">
        <div className="Teaser--header"></div>
        <h3 className="Teaser--title">
          <span className="Link layout-standalone size-small">
            Einverständniserklärung zur begleitenden Datenerhebung zu
            Forschungszwecken auf der FormATool-Webseite
          </span>
        </h3>
      </div>
      <div className="Teaser--body">
        <div className={`Teaser--text richtext`}>
          <p>
            Liebe Lehrpersonen
            <br />
            Gerne möchten wir Ihnen vorab einige wichtige Informationen zur
            begleitenden Datenerhebung zu Forschungszwecken auf der
            FormATool-Webseite geben und um Ihre informierte Einwilligung in die
            Teilnahme bitten.
          </p>
          <h4>1. Inhalt und Dauer der Befragung </h4>
          <p>
            Bei FormATool handelt es sich um ein für Lehrpersonen entwickeltes
            Online-Tool mit dem Fokus auf kognitiver Aktivierung, das von
            Lehrpersonen selbstgesteuert eingesetzt werden kann. Die
            Beantwortung einer Befragung, die Sie als Lehrperson anlegen, dauert
            ca. 5 Minuten. Zur Onlinebefragung zu Ihrem Unterricht können Sie
            weitere Perspektiven (Beobachtende und Schüler*innen) einladen.
            Deren Befragung zum Unterricht dauert auch ca. 5 Minuten. Sie als
            Lehrperson erhalten im Anschluss eine automatisierte Auswertung der
            Befragung, in der die unterschiedlichen Einschätzungen der
            kognitiven Aktivierung Ihres Unterrichts ersichtlich sind. Ziel der
            Umfragen ist es, eine selbständig steuerbare Rückmeldung zum
            Unterricht einzuholen und somit evidenzbasierte
            Unterrichtsentwicklung zu ermöglichen.
          </p>
          <h4>2. Institutioneller Rahmen</h4>{" "}
          <p>
            Das Projekt wird am Lehrstuhl für pädagogisch-psychologische
            Lehr-Lernforschung und Didaktik am Institut für
            Erziehungswissenschaft der Universität Zürich durchgeführt. Die
            Projektleitung haben Prof. Dr. Anna-Katharina Praetorius und Wida
            Wemmer-Rogh inne.
          </p>
          <h4>3. Nutzen und Risiken einer Teilnahme </h4>
          <p>
            Durch Ihre Teilnahme leisten Sie einen wertvollen Beitrag zur
            Forschung zur kognitiven Aktivierung und helfen mit, die Plattform
            FormATool weiter zu optimieren. Die mit der Teilnahme verbundenen
            Risiken werden als gering eingeschätzt. Die Verwendung des Angebots
            auf der FormATool-Webseite geht mit den gleichen Risiken einher, die
            bei der alltäglichen Internetnutzung bestehen (z. B. nicht
            auszuschliessende Möglichkeit, dass Informationen über das Internet
            unerlaubt von Dritten abgefangen werden) und die nicht der Kontrolle
            der Forschenden unterliegen. Massnahmen zum Datenschutz sind unten
            beschrieben.
          </p>
          <h4>4. Freiwilligkeit der Teilnahme</h4>
          <p>
            Ihre Teilnahme an diesem Projekt ist freiwillig und durch die
            Nicht-Teilnahme entstehen keine Nachteile für Sie. Sie können die
            Umfragen jederzeit und ohne Angabe von Gründen abbrechen.{" "}
          </p>
          <h4>5. Daten und Datenschutz</h4>
          <p>
            Um die Forschung zur kognitiven Aktivierung weiter voranzutreiben
            und die Plattform weiter zu optimieren, werden die in den Umfragen
            erfassten Datenn vertraulich behandelt, anonym ausgewertet und
            ausschliesslich für wissenschaftliche Zwecke verwendet. Von den
            Ergebnissen sind keine Rückschlüsse auf die Angaben einzelner
            Personen möglich. Die persönlichen Daten (E-Mail), werden
            automatisch getrennt von Ihren übrigen Angaben in dieser Befragung
            gespeichert. Der Serverstandort des Fragebogens ist in der Schweiz.
            Die anonymen Daten werden an der Universität Zürich ausgewertet.{" "}
          </p>
          <h4>6. Fragen</h4>
          <p>
            Bei Fragen und Bemerkungen wenden Sie sich bitte an das Projektteam
            (E-Mail:{" "}
            <a href="mailto:formatool@ife.uzh.ch">formatool@ife.uzh.ch</a>).
          </p>
          <FormSingleCheckbox
            label="Ich habe obige Informationen gelesen und verstanden. Allfällige Fragen wurden mir auf zufriedenstellende Weise beantwortet. Auf Grundlage der erhaltenen Informationen nehme ich freiwillig an dem Projekt teil."
            checked={optIn === true}
            onClick={() =>
              setOptIn((prevState) =>
                prevState === undefined ? true : !prevState
              )
            }
          />
          <FormSingleCheckbox
            label="Ich nehme nicht an dem Projekt teil."
            checked={optIn === false}
            onChange={() =>
              setOptIn((prevState) =>
                prevState === undefined ? false : !prevState
              )
            }
          />
        </div>
        <div
          className="FormButtons"
          style={{ display: "flex", justifyContent: "flex-end" }}
        >
          <button
            className="Button size-large"
            onClick={() => setRegisterModal(false)}
            autoFocus
          >
            Schliessen
          </button>
          <button
            className="Button color-primary size-large"
            onClick={() => {
              if (optIn) register();
              else navigate("/registrieren/abbruch");
            }}
          >
            Absenden
          </button>
        </div>
      </div>
    </Modal>
  );
}
